import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/contexts/AuthContext";
import { isTenantManagerPlus } from "@/shared/lib/rbac";
import { wecomAppService, type WeComModule } from "../api/wecomAppService";
import { hasEnabledWeComApp } from "./wecomRequired";

/**
 * 该模块在本租户是否已绑定启用中的企微应用。三态:
 * `true` 已绑 / `false` 确认没绑 / `undefined` 查不到(无权限、加载中、接口失败)——
 * 调用方在 undefined 时不要下结论(横幅不误报、提示不说「已发送」也不说「发不出」)。
 * 与 {@link WeComRequiredBanner} 共用同一个 query key,一页内只查一次。
 */
export function useWeComModuleBound(module: WeComModule): boolean | undefined {
  const { effectiveRole } = useAuth();
  const canQuery = isTenantManagerPlus(effectiveRole);
  const { data, isSuccess } = useQuery({
    queryKey: ["wecom-apps-required", module],
    queryFn: () => wecomAppService.listApps(0, module),
    enabled: canQuery,
    staleTime: 60_000,
    retry: false,
  });
  if (!canQuery || !isSuccess) return undefined;
  return hasEnabledWeComApp(data, module);
}
